module.exports = ":host {\n  display:block;\n}\n\n:host[data-padding=\"centered\"] .content {\n  position:fixed;\n  top:50%;\n  left:50%;\n  width:80%;\n  -webkit-transform:translateX(-50%) translateY(-50%);\n          transform:translateX(-50%) translateY(-50%);\n}\n\n:host:not([data-padding]) .content {\n  padding:5rem;\n}\n\n:host[data-padding=\"plain\"] .content {\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/slide/slide.component.css
// module id = ./src/app/slide/slide.component.css
// module chunks = main